<template>
  <!-- Wfrop table -->
  <div>
    <div class="wfrop__header">
      # Visible Light Transmittance
    </div>
    <div class="wfrop__row">
      <div class="label">Window-to-wall ratio (only glass) is:</div>
      <div class="value">{{ step4.vltObj.window_wall_ratio }}</div>
    </div>
    <div class="wfrop__row">
      <div class="label">The recommended VLT for the WWR range {{ minRange }} - {{ maxRange }} is :</div>
      <div class="value">{{ step4.vltObj.required_vlt }}</div>
    </div>

    <div class="step4-conclusion-wrap">
      <div class="step4-conclusion-head">Conclusion:</div>
      <v-alert dense type="success" text>
        <div class="step4-wfrop-conclusion">The recommended VLT value for the project as per the ECBC-R is {{ step4.vltObj.required_vlt || `---` }}</div>
      </v-alert>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      minRange: 0.0,
      maxRange: 0,
    };
  },
  computed: {
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },
    step3B: {
      get: function() {
        return this.$store.state.schema.inputs.step3B;
      },
      set: function(step3B) {
        this.$store.dispatch('setStep3B', step3B);
      },
    },
    step3C: {
      get: function() {
        return this.$store.state.schema.inputs.step3C;
      },
      set: function(step3C) {
        this.$store.dispatch('setStep3C', step3C);
      },
    },
    step4: {
      get: function() {
        return this.$store.state.schema.inputs.step4;
      },
      set: function(step3C) {
        this.$store.dispatch('setStep4', step4);
      },
    },

    // 0.00 - 0.30	0.27
    // 0.31 - 0.40	0.20
    // 0.41 - 0.50	0.16
    // 0.51 - 0.60	0.13
    // 0.61 - 0.70	0.11
  },
  beforeMount() {
    this.calcWindowToWallRatio();
    this.requiredVlt();
  },
  methods: {
    calcWindowToWallRatio() {
      this.step4.vltObj.window_wall_ratio = (+this.step3B.summary_window_glass.total_glass_area / +this.schema.inputs.step3A.summary.total_wall_surface_area).toFixed(2);
      // +this.step3C.summary_ventilator_openable.total_glass_area +
    },
    requiredVlt() {
      this.minRange = 0.0;
      this.maxRange = 0;
      if (this.step4.vltObj.window_wall_ratio <= 0.3) {
        this.step4.vltObj.required_vlt = 0.27;
        this.minRange = 0.0;
        this.maxRange = 0.3;
        return 0.27;
      } else if (this.step4.vltObj.window_wall_ratio >= 0.31 && this.step4.vltObj.window_wall_ratio <= 0.4) {
        this.step4.vltObj.required_vlt = 0.2;
        this.minRange = 0.31;
        this.maxRange = 0.4;
        return 0.2;
      } else if (this.step4.vltObj.window_wall_ratio >= 0.41 && this.step4.vltObj.window_wall_ratio <= 0.5) {
        this.step4.vltObj.required_vlt = 0.16;
        this.minRange = 0.41;
        this.maxRange = 0.5;
        return 0.16;
      } else if (this.step4.vltObj.window_wall_ratio >= 0.51 && this.step4.vltObj.window_wall_ratio <= 0.6) {
        this.step4.vltObj.required_vlt = 0.13;
        this.minRange = 0.51;
        this.maxRange = 0.6;
        return 0.13;
      } else if (this.step4.vltObj.window_wall_ratio >= 0.61 && this.step4.vltObj.window_wall_ratio <= 0.7) {
        this.step4.vltObj.required_vlt = 0.11;
        this.minRange = 0.61;
        this.maxRange = 0.7;
        return 0.11;
      }
    },
  },
};
</script>

<style lang="scss">
.wfrop__header {
  background-color: #e5f3fe;
  padding: 12px 24px;
  color: #309df4;
  font-size: 20px;
  text-align: left;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  display: flex;
}

.wfrop__row {
  outline: 1px solid #dedede;

  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 6px;
  border-bottom: 1px solid #dedede;
  .label {
    width: 280px;
  }
  .value {
    width: 100px;
  }
}
</style>
